import { QueryClient } from '@tanstack/react-query';

let _queryClient: QueryClient | null = null;

const getQueryClient = (): QueryClient => {
  if (!_queryClient) {
    _queryClient = new QueryClient();
  }
  return _queryClient;
};

export const queryClient = getQueryClient();
